import { useRef, useState } from "react";
import { useRouter } from "next/router";
import Image from "next/image";
import { IoSearchOutline } from "react-icons/io5";
import LocationSearchPopover from "@/Component/Module/HolidayListing/LocationSearchPopover";
import LocationSearchScreen from "@/Component/Module/HolidayListing/LocationSearchScreen";
import useIsDesktop from "@/hooks/useIsDesktop";
import useBodyScrollLock from "@/hooks/useBodyScrollLock";
import { buildSearchListHref, getSearchDisplayLabel } from "@/utils/holidaySearch";
import { withRegionPath } from "@/utils/session";
import { beginListingSearch } from "@/utils/listingFilterSession";
import SmartSearchModal from "@/Component/Module/HolidaySmartSearch/SmartSearchModal";
import styles from "./Header.module.css";

export default function HolidayHeaderSearch() {
  const router = useRouter();
  const inputWrapRef = useRef(null);
  const [query, setQuery] = useState("");
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);
  const [smartSearchOpen, setSmartSearchOpen] = useState(false);
  const { isDesktop, mounted } = useIsDesktop(900);

  useBodyScrollLock(mobileSearchOpen);

  const navigateToSelection = (item) => {
    if (!item) return;

    setQuery(getSearchDisplayLabel(item, item.label));
    setPopoverOpen(false);
    setMobileSearchOpen(false);
    beginListingSearch("holiday");
    router.push(withRegionPath(buildSearchListHref(item)));
  };

  const openMobileSearch = () => {
    setPopoverOpen(false);
    setMobileSearchOpen(true);
  };

  const handleDesktopChange = (event) => {
    setQuery(event.target.value);
    setPopoverOpen(true);
  };

  const handleDesktopFocus = () => {
    setPopoverOpen(true);
  };

  const isMobileSearch = mounted && !isDesktop;

  return (
    <>
      <div className={styles.searchRow}>
        <div className={styles.inputWrap} ref={inputWrapRef}>
          <input
            className={styles.input}
            type="search"
            placeholder="Search Countries, cities..."
            value={query}
            onChange={isMobileSearch ? undefined : handleDesktopChange}
            onFocus={isMobileSearch ? openMobileSearch : handleDesktopFocus}
            onClick={isMobileSearch ? openMobileSearch : undefined}
            readOnly={isMobileSearch}
            autoComplete="off"
            aria-label="Search destinations"
            aria-expanded={popoverOpen || mobileSearchOpen}
            aria-haspopup="listbox"
          />
          <span className={styles.searchIcon} aria-hidden="true">
            <IoSearchOutline size={24} />
          </span>
          {mounted && isDesktop && popoverOpen ? (
            <LocationSearchPopover
              anchorRef={inputWrapRef}
              query={query}
              onClose={() => setPopoverOpen(false)}
              onSelect={navigateToSelection}
              className={styles.headerSearchPopover}
            />
          ) : null}
        </div>

        <button
          type="button"
          className={styles.smartBtn}
          onClick={() => {
            setPopoverOpen(false);
            setMobileSearchOpen(false);
            setSmartSearchOpen(true);
          }}
        >
          <Image src="/assets/icons/smartsearch.svg" alt="" width={30} height={30} quality={70} loading="lazy" />
          Smart Search
        </button>
      </div>

      <SmartSearchModal
        open={smartSearchOpen}
        onClose={() => setSmartSearchOpen(false)}
      />

      {isMobileSearch && mobileSearchOpen ? (
        <LocationSearchScreen
          initialQuery={query}
          onClose={() => setMobileSearchOpen(false)}
          onSelect={navigateToSelection}
        />
      ) : null}
    </>
  );
}
